import React from 'react';

import './AppFooter.css';

export default function AppFooter() {
  return (
      <footer className="footer">
        <hr />
        &copy; All brand logos are trademarks of their respective owners.
        <p />
        The PartSelect logo is a Registered Trademark of Atlantic Laundry Centres, Ltd.
        <p />
        Copyright © 1999-2024, Eldis Group Partnership. All rights reserved.
      </footer>
  );
};
